import { useCallback } from 'react';

import { useGlobalModalLaunchContext } from '../../../../contexts/modal-context/global-modal-context';
import { useShipmentVolumeUpgrade } from '../../../purchase-shipment-volume/use-can-purchase-shipment-volume';

export const useOpenUpgradeDrawer = (onClose: () => void) => {
  const { openManageSubscriptionDrawer } = useGlobalModalLaunchContext() ?? {};
  const { maxPlanShipmentLimit, upgradeDrawerProps } = useShipmentVolumeUpgrade();

  const handleManagePlan = useCallback(() => {
    openManageSubscriptionDrawer?.(upgradeDrawerProps);
    onClose();
  }, [onClose, openManageSubscriptionDrawer, upgradeDrawerProps]);

  return { handleManagePlan, maxPlanShipmentLimit };
};
